import { useState } from "react";
import { ChevronDown } from "lucide-react";

export default function FAQAccordion({ items }) {
  const [open, setOpen] = useState(0);
  return (
    <div className="space-y-3" data-testid="faq-list">
      {items.map((it, i) => {
        const isOpen = open === i;
        return (
          <div key={i} className="bg-white rounded-2xl border border-border/50 overflow-hidden">
            <button
              data-testid={`faq-toggle-${i}`}
              onClick={() => setOpen(isOpen ? -1 : i)}
              className="w-full flex justify-between items-center py-5 px-6 font-extrabold text-left hover:text-primary"
            >
              <span>{it.q}</span>
              <ChevronDown size={20} className={`transition-transform ${isOpen ? "rotate-180" : ""}`} />
            </button>
            {isOpen && (
              <div className="px-6 pb-6 text-muted-foreground leading-relaxed" data-testid={`faq-content-${i}`}>
                {it.a}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
